import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { Button, Col, Panel, Row } from "react-bootstrap";

import CommonFunctions from "../../commonFunctions";
import * as consts from "../../constants";

import CurrencyInput from "../common/CurrencyInput";
import TextAreaInput from "../common/TextAreaInput";
import TextInput from "../common/TextInput";
import TextViewer from "../common/TextViewer";

const PianoFlexSection = ({
  commonState,
  contract,
  addWarranty,
  deleteWarranty,
  onChange,
  productSelected,
}) => {
  const isPersonaGiuridica =
    _.toNumber(contract.personType) === consts.GENERIC_ENUM.personType[1].value;

  var disabledFlag = false;
  var hidden = "";

  contract.pianoFlex.netAmount = 0;
  contract.pianoFlex.quotaIscrizione = 0;
  contract.pianoFlex.grossAmount = 0;

  //Modificare gli ID in base al prodotto FLEX per cui bloccare i campi

  if (contract.productId === "9" || contract.productId === "10") {
    contract.pianoFlex.name = productSelected.name;
    disabledFlag = true;
    hidden = "hidden";
  } else {
    contract.pianoFlex.name = contract.pianoFlex.name;
    disabledFlag = false;
    hidden = "";
  }

  if (contract.productId === "10") {
    contract.pianoFlex.pfSubscriberFee = 45;
  }

  if (contract.productId === "9") {
    contract.pianoFlex.pfSubscriberFee = 45;
  }

  if (isPersonaGiuridica) {
    contract.pianoFlex.pfSubscriberFee = 100;
  }

  if (
    contract &&
    contract.pianoFlex &&
    contract.pianoFlex.pianoFlexWarranty &&
    contract.pianoFlex.pianoFlexWarranty
  ) {
    // Calculate Net
    for (
      var i = 0, _len = contract.pianoFlex.pianoFlexWarranty.length;
      i < _len;
      i++
    )
      contract.pianoFlex.netAmount +=
        contract.pianoFlex.pianoFlexWarranty[i].amount;

    // Calculate Quote
    const quotaIscrizioneAndQuota =
      CommonFunctions.getValuesForQuotaIscrizioneAndQuotaPianoFlex(
        contract,
        commonState
      );
    
    contract.pianoFlex.quotaIscrizione =
      quotaIscrizioneAndQuota.quotaIscrizione;

    // Calculate Total
    contract.pianoFlex.grossAmount =
      contract.pianoFlex.netAmount + contract.pianoFlex.quotaIscrizione;
  }

  return (
    <Row>
      <Col md={12}>
        <Panel bsStyle="default" className=" x-panel-green">
          <Panel.Heading>Dettaglio Piano {productSelected.name}</Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={12}>
                <TextInput
                  id="pianoFlex.name"
                  label="Nome Piano Mutualistico"
                  name="pianoFlex.name"
                  required={true}
                  value={contract.pianoFlex.name}
                  onChange={onChange}
                  disabled={disabledFlag}
                />
              </Col>
            </Row>
            <Panel bsStyle="default" className=" x-panel-azzurroChiaro">
              <Panel.Heading>Quote</Panel.Heading>
              <Panel.Body>
                {isPersonaGiuridica ? (
                  <Row>
                    <Col md={12}>
                      <h4>Quote Aziendali</h4>
                    </Col>
                    <Col md={12}>
                      <CurrencyInput
                        defaultValue={0}
                        label="Quota Azienda"
                        name="pianoFlex.pgFactoryFee"
                        onChange={onChange}
                        value={contract.pianoFlex.pgFactoryFee}
                      />
                    </Col>
                    <Col md={12}>
                      <CurrencyInput
                        defaultValue={0}
                        label="Quota Dipendente"
                        name="pianoFlex.pgEmployeeFee"
                        onChange={onChange}
                        value={contract.pianoFlex.pgEmployeeFee}
                      />
                    </Col>
                    <Col md={12}>
                      <CurrencyInput
                        defaultValue={0}
                        label="Quota Familiare del Dipendente"
                        name="pianoFlex.pgRelativeFee"
                        onChange={onChange}
                        value={contract.pianoFlex.pgRelativeFee}
                      />
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col md={12}>
                      <h4>Quote Famiglia</h4>
                    </Col>
                    <Col md={12}>
                      <CurrencyInput
                        defaultValue={0}
                        label="Quota Caponucleo"
                        name="pianoFlex.pfSubscriberFee"
                        onChange={onChange}
                        value={contract.pianoFlex.pfSubscriberFee}
                        disabled={disabledFlag}
                      />
                    </Col>
                    <Col md={12}>
                      <CurrencyInput
                        defaultValue={0}
                        label="Quota Familiare del Caponucleo"
                        name="pianoFlex.pfRelative"
                        onChange={onChange}
                        value={contract.pianoFlex.pfRelative}
                        disabled={disabledFlag}
                      />
                    </Col>
                  </Row>
                )}
              </Panel.Body>
            </Panel>
            <Panel bsStyle="default" className=" x-panel-verdeChiaro">
              <Panel.Heading>Prestazioni</Panel.Heading>
              <Panel.Body>
                <Row>
                  {contract.pianoFlex.pianoFlexWarranty.map((warranty) => (
                    <Col md={12} key={warranty.id}>
                      <Panel bsStyle="default" className=" x-panel-orange">
                        <Panel.Heading>{warranty.name}</Panel.Heading>
                        <Panel.Body>
                          <Row>
                            <Col md={12}>
                              <TextInput
                                disabled={warranty.id > -1 ? "disabled" : ""}
                                label="Nome"
                                name={
                                  "pianoFlex.warranty." + warranty.id + ".name"
                                }
                                onChange={onChange}
                                required={true}
                                value={warranty.name}
                              />
                            </Col>
                            <Col md={12}>
                              <TextInput
                                disabled={warranty.id > 0 || disabledFlag}
                                label="Note Stampate"
                                name={
                                  "pianoFlex.warranty." +
                                  warranty.id +
                                  ".printedNote"
                                }
                                onChange={onChange}
                                className={hidden}
                                value={warranty.printedNote}
                              />
                            </Col>
                            <Col md={12}>
                              <CurrencyInput
                                disabled={warranty.id > 0}
                                label="Importo Totale"
                                name={
                                  "pianoFlex.warranty." +
                                  warranty.id +
                                  ".amount"
                                }
                                onChange={onChange}
                                value={warranty.amount}
                              />
                            </Col>
                            {warranty.id < 0 ? (
                              <Col md={12}>
                                <Button
                                  className="btn btn-warning"
                                  onClick={() => deleteWarranty(warranty.id)}
                                  style={{ marginBottom: 30 }}
                                >
                                  Rimuovi Prestazione
                                </Button>
                              </Col>
                            ) : (
                              ""
                            )}
                          </Row>
                        </Panel.Body>
                      </Panel>
                    </Col>
                  ))}
                </Row>
                <Row>
                  <Col md={12}>
                    <Button
                      bsStyle="primary"
                      onClick={addWarranty}
                      disabled={disabledFlag}
                    >
                      Aggiungi Prestazione
                    </Button>
                  </Col>
                </Row>
              </Panel.Body>
            </Panel>
            <Row>
              <Col md={12}>
                <TextAreaInput
                  label="Note"
                  name="pianoFlex.note"
                  required={true}
                  value={contract.pianoFlex.note}
                  onChange={onChange}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </Col>
      <Col md={12}>
        <Panel bsStyle="default" className=" x-panel">
          <Panel.Heading>
            <span
              className="glyphicon glyphicon-list"
              aria-hidden="true"
            ></span>{" "}
            Contributi
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={12}>
                *Nota: nel caso di persona giuridica si ha un importo al netto
                della quota associativa
              </Col>
              <Col md={12}>
                <TextViewer
                  label="Costo Netto Annuale"
                  value={CommonFunctions.numberToItalianEuroFormat(
                    contract.pianoFlex.netAmount
                  )}
                />
              </Col>
              <Col md={12}>
                <TextViewer
                  label="Quota"
                  value={CommonFunctions.numberToItalianEuroFormat(
                    contract.pianoFlex.quotaIscrizione
                  )}
                />
              </Col>
              <Col md={12}>
                <TextViewer
                  label="Costo Lordo Annuale"
                  value={CommonFunctions.numberToItalianEuroFormat(
                    contract.pianoFlex.grossAmount
                  )}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </Col>
    </Row>
  );
};

PianoFlexSection.propTypes = {
  addWarranty: PropTypes.func.isRequired,
  commonState: PropTypes.object.isRequired,
  contract: PropTypes.object.isRequired,
  deleteWarranty: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PianoFlexSection;
